import React from "react";
import { CustomRadioGroup } from "../../../common/FormInputs";
import {
  StyledFormElementsWrapper,
  StyledFormElementsWrapper1,
  StyledLabel,
} from "../Styles";

const CaseTypeRadioButton = ({ values, handleChange, resolutionKind }) => {
  const handleSubscriptionTypeChange = (e) => {
    handleChange(e, "subscriptionType");
  };

  return (
    <>
      <StyledFormElementsWrapper1 style={{ marginBottom: 15, marginTop: 15 }}>
        <StyledLabel>Select a Case Type</StyledLabel>
        <CustomRadioGroup
          radioInputs={[
            { label: "Negotiation", value: "negotiation" },
            { label: "Mediation", value: "mediation" },
            { label: "Arbitration", value: "arbitration" }
          ]}
          name={"resolutionKind"}
          handleChange={e => handleChange(e, "resolutionKind")}
          {...{ values }}
        />
      </StyledFormElementsWrapper1>
      {(resolutionKind === "mediation" || resolutionKind === "arbitration") && (
        <StyledFormElementsWrapper style={{ marginBottom: 15, marginTop: 15 }}>
          {resolutionKind === "mediation" ? (
            <StyledLabel>Select Mediator Type</StyledLabel>
          ) : (
            <StyledLabel>Select Arbitrator Type</StyledLabel>
          )}
          <div className="mediator-type">
            <CustomRadioGroup
              radioInputs={[
                {
                  label: `${
                    values?.resolutionKind === "mediation"
                      ? "IAMC Institutional Mediation – with IAMC Mediation Panel & Rules"
                      : "IAMC Institutional Arbitration – with IAMC Arbitral Panel & Rules"
                      
                  }`,
                  value: "normal"
                },
                {
                  label: `${
                    values?.resolutionKind === "mediation"
                      ? "Adhoc Mediation – with parties’ agreed upon Mediation Panel & Rules"
                      : "Adhoc Arbitration – with parties’ agreed upon Arbitral Panel & Rules"
                  }`,
                  value: "adhoc"
                },

                {
                  label: `${
                    values?.resolutionKind === "mediation"
                      ? "Court Referred"
                      : "Court Referred"
                  }`,
                  value: "courtreferred"
                }
                // {
                //   label: `I want JustAct's ${
                //     values?.resolutionKind === "mediation"
                //       ? "mediator"
                //       : "arbitrator"
                //   } to resolve the dispute
                //       according to JustAct Rules`,
                //   value: "normal",
                // },
                // {
                //   label: `I submit that the parties wish to use the JustAct platform for conducting the ${
                //     values?.resolutionKind
                //   } ${values.resolutionKind === "mediation"
                //       ? "with a"
                //       : "with an"}
                //   ${
                //     values?.resolutionKind === "mediation"
                //       ? "mediator"
                //       : "arbitrator"
                //   } of our choice; Rules have been agreed between us`,
                //   value: "adhoc",
                // },
              ]}
              name={"subscriptionType"}
              handleChange={handleSubscriptionTypeChange}
              {...{ values }}
            />
          </div>
        </StyledFormElementsWrapper>
      )}
      {resolutionKind === "arbitration" && (
        <StyledFormElementsWrapper style={{ marginBottom: 15, marginTop: 15 }}>
          <StyledLabel>Select Type of Arbitration</StyledLabel>
          <CustomRadioGroup
            radioInputs={[
              { label: "Domestic", value: "domestic" },
              { label: "International", value: "international" },
            ]}
            name={"typeOfArbitration"}
            handleChange={(e) => handleChange(e, "typeOfArbitration")}
            {...{ values }}
          />
        </StyledFormElementsWrapper>
      )}
      {resolutionKind === "arbitration" && (
        <StyledFormElementsWrapper style={{ marginBottom: 15, marginTop: 15 }}>
          <StyledLabel>Emergency Arbitration</StyledLabel>
          <CustomRadioGroup
            radioInputs={[
              { label: "Yes", value: "yes" },
              { label: "No", value: "no" },
            ]}
            name={"emergencyArbitration"}
            handleChange={(e) => handleChange(e, "emergencyArbitration")}
            {...{ values }}
          />
        </StyledFormElementsWrapper>
      )}
    </>
  );
};

export default CaseTypeRadioButton;
